import React, { useState, useEffect } from 'react';
import {
  Box,
  Card,
  CardContent,
  IconButton,
  // Switch,
  // FormControlLabel,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import '../../components/Settings/Settings.css';
import apiService from '../../services/api';

const ProfileTab = (/* { isChatbotVisible, toggleChatbot } */) => {
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [imageUrl, setImageUrl] = useState('');
  const [userRole, setUserRole] = useState('');
  // const [globalChatbotEnabled, setGlobalChatbotEnabled] = useState(null);

  useEffect(() => {
    // Load user data from sessionStorage
    setFullName(sessionStorage.getItem('user_name') || '');
    setEmail(sessionStorage.getItem('user_emailId') || '');
    setImageUrl(sessionStorage.getItem('image_url') || '');
    setUserRole(sessionStorage.getItem('user_role') || '');

    // Fetch global chatbot state
    /* apiService.fetchData('botstate')
      .then((response) => {
        if (response.status === 'success' && response.results?.length > 0) {
          setGlobalChatbotEnabled(response.results[0].Enabled);
        } else {
          console.error('Failed to fetch global bot state:', response.message || 'Invalid response');
          setGlobalChatbotEnabled(false);
        }
      })
      .catch((error) => {
        console.error('Error fetching global bot state:', error.message || error);
        setGlobalChatbotEnabled(false);
      }); */
  }, []);

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append('email', email);
      formData.append('image', file);

      apiService.uploadProfileImage(formData)
        .then((result) => {
          if (result.status === 'success' && result.image_url) {
            sessionStorage.setItem('image_url', result.image_url);
            setImageUrl(result.image_url);
            window.dispatchEvent(new Event('profileImageUpdated'));
            console.log('Profile image uploaded successfully:', result.image_url);
          } else {
            console.error('Upload error:', result.message || 'Invalid response');
          }
        })
        .catch((error) => {
          console.error('Upload failed:', error.message || error);
        });
    } else {
      console.error('No file selected');
    }
  };

  /* const handleGlobalChatbotToggle = () => {
    const newState = !globalChatbotEnabled;
    const userId = sessionStorage.getItem('user_id') || '891';

    const payload = {
      chatbot_state: newState,
      updated_by: parseInt(userId),
    };

    apiService.putData('botstate', payload)
      .then((response) => {
        if (response.status === 'success') {
          setGlobalChatbotEnabled(newState);
          if (!newState && isChatbotVisible) {
            toggleChatbot();
          }
        } else {
          console.error('Failed to update global bot state:', response.message || 'Invalid response');
        }
      })
      .catch((error) => {
        console.error('Failed to update global bot state:', error.message || error);
      });
  }; */

  return (
    <Box className="settings-container">
      <h2 id="settings1" className="profile-title">Profile</h2>

      <div
        className="profile-tab"
        style={{ display: 'flex', gap: '20px', alignItems: 'stretch' }}
      >
        {/* LEFT COLUMN */}
        <div style={{ display: 'flex', flexDirection: 'column', width: '300px' }}>
          
          {/* Profile image card */}
          <Card style={{ flex: 1, height: '100%' }}>
            <CardContent className="profile-card-content" style={{ textAlign: 'center' }}>
              <div className="profile-image-container">
                <img
                  src={imageUrl}
                  alt="Profile"
                  className="profile-image"
                />
                <div className="image-overlay">
                  <IconButton
                    color="inherit"
                    component="label"
                    className="upload-icon"
                  >
                    <EditIcon />
                    <input
                      type="file"
                      accept="image/*"
                      hidden
                      onChange={handleImageUpload}
                    />
                  </IconButton>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Chatbot settings card under profile image
          {globalChatbotEnabled !== null && (
            <Card style={{ marginTop: '16px', width: '100%' }}>
              <CardContent
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  gap: 1,
                  padding: '16px',
                }}
              >
                {userRole === '1' && (
                  <FormControlLabel
                    control={
                      <Switch
                        checked={globalChatbotEnabled}
                        onChange={handleGlobalChatbotToggle}
                        color="primary"
                      />
                    }
                    label={globalChatbotEnabled ? 'Global Chatbot ON' : 'Global Chatbot OFF'}
                  />
                )}
                {['1', '2', '3', '4'].includes(userRole) && globalChatbotEnabled && (
                  <FormControlLabel
                    control={
                      <Switch
                        checked={isChatbotVisible}
                        onChange={toggleChatbot}
                        color="primary"
                        disabled={!globalChatbotEnabled}
                      />
                    }
                    label={isChatbotVisible ? 'Personal Chatbot ON' : 'Personal Chatbot OFF'}
                  />
                )}
              </CardContent>
            </Card>
          )}
          */}
        </div>

        {/* RIGHT COLUMN */}
        <Card style={{ flex: 1, height: '100%' }}>
          <CardContent className="profile-card-content">
            <div className="profile-details">
              <h3 className="detail-title" id="settings22">Full Name</h3>
              <p className="detail-text" id="settings2">{fullName}</p>
              <h3 className="detail-title" id="settings22">Email ID</h3>
              <p className="detail-text" id="settings2">{email}</p>
            </div>
          </CardContent>
        </Card>
      </div>
    </Box>
  );
};

export default ProfileTab;